import {
	MenuToggleItem,
	PopupMenu,
	PopupMenuElement,
} from 'room/common/presentation/menu'
// import ScreenShareIcon from './screen-share-icon'
import { colors, intl } from '@beelday/common'
import useParamTogglerApi from 'features/param-toggler/param-toggler-api'
import { useTranslatedMessage } from 'intl/translate'
import { useAssertedJoinedRoomAddress } from 'room/common/use-joined-room-address'
import {
	RecordingActiveIcon,
	RecordingIcon,
} from 'room/common/presentation/icon/recording-icon'
import { useRecordingState } from './recording-context'

type Props = {
	hidden?: boolean
}

const RecordingTrainerMenuItem = ({ hidden }: Props): JSX.Element | null => {
	const paramTogglerApi = useParamTogglerApi()
	const address = useAssertedJoinedRoomAddress()
	const reshareRecordingText = useTranslatedMessage(
		'room_menu.recording.reshare'
	)
	const startRecordingText = useTranslatedMessage('room_menu.recording.start')
	const resumeRecordingText = useTranslatedMessage('room_menu.recording.resume')
	const stopRecordingText = useTranslatedMessage('room_menu.recording.stop')

	const { reshareRecording, resumeRecording, uiState } = useRecordingState()
	const statusText = useTranslatedMessage(uiState.messageKey)
	const startActionText = uiState.canResume
		? resumeRecordingText
		: startRecordingText
	const statusStyle =
		uiState.severity === 'warning'
			? { color: '#f49126', fontStyle: 'italic' }
			: uiState.severity === 'error'
			? { color: colors.pinkRed, fontStyle: 'italic' }
			: { fontStyle: 'italic' }

	if (hidden) return null

	return (
		<MenuToggleItem
			active={uiState.active}
			icon={<RecordingIcon />}
			activeIcon={<RecordingActiveIcon />}
			label={<intl.Translate>room_menu.recording</intl.Translate>}
		>
			<PopupMenu>
				<>
					<PopupMenuElement text={statusText} style={statusStyle} />
					{uiState.canStart || uiState.canResume ? (
						<PopupMenuElement
							text={startActionText}
							onClick={() => {
								if (uiState.canResume) {
									void resumeRecording().catch(error => {
										console.warn('Failed to resume recording', error)
									})
								} else {
									paramTogglerApi.toggleOnParam(address, 'recording')
								}
							}}
						/>
					) : null}
					{uiState.canReshare ? (
						<PopupMenuElement
							text={reshareRecordingText}
							onClick={() => {
								void reshareRecording().catch(error => {
									console.warn('Failed to restore recording share', error)
								})
							}}
						/>
					) : null}
					{uiState.canStop ? (
						<PopupMenuElement
							text={stopRecordingText}
							onClick={() => {
								paramTogglerApi.toggleOffParam(address, 'recording')
							}}
							style={{ color: colors.pinkRed, fontWeight: 'bolder' }}
						/>
					) : null}
				</>
			</PopupMenu>
		</MenuToggleItem>
	)
}

export default RecordingTrainerMenuItem
